import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import Portfolio from "@/components/Portfolio";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import JsonLd from "@/components/JsonLd";

const CursorLegend = () => (
  <div className="hidden lg:flex items-center justify-center gap-24 py-16 bg-background">
    <div className="flex flex-col items-center gap-2">
      <div 
        className="w-4 h-4 rounded-full" 
        style={{ backgroundColor: 'rgb(65, 102, 10)' }}
      />
      <span className="text-sm text-muted-foreground tracking-wide">move</span>
    </div>
    <div className="flex flex-col items-center gap-2">
      <div 
        className="w-4 h-4 rounded-full" 
        style={{ backgroundColor: 'rgb(75, 0, 130)' }}
      />
      <span className="text-sm text-muted-foreground tracking-wide">enter</span>
    </div>
  </div>
);

const Index = () => {
  return (
    <main className="min-h-screen">
      <SEOHead path="/" />
      <JsonLd type={['Organization', 'WebSite', 'LocalBusiness', 'Person']} />
      <Navigation />
      <Hero />
      <CursorLegend />
      <HowItWorks />
      <Portfolio />
      <About />
      <Testimonials />
      <CTA />
      <Footer />
    </main>
  );
};

export default Index;
